import { render, staticRenderFns } from "./LandingAbout.vue?vue&type=template&id=501514c2&"
import script from "./LandingAbout.vue?vue&type=script&lang=js&"
export * from "./LandingAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports